import { render, staticRenderFns } from "./SideTooltipMenu.vue?vue&type=template&id=6ccf548f&scoped=true&"
import script from "./SideTooltipMenu.vue?vue&type=script&lang=js&"
export * from "./SideTooltipMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccf548f",
  null
  
)

export default component.exports